import ReactTextCollapse from './ReactTextCollapse'
export default ReactTextCollapse
